import { useEffect, useState } from "react";
import { getArtistHubExtras } from "../api";

// Photos for a short list of artist ids ({id: url}), from the public, cached
// /hub-extras route - the same photo the artist's profile and link page show
// (the claimed owner's avatar, else the stored Soundcharts image). Ids without
// a photo are left out, so callers fall back to initials.
export default function useArtistPhotos(ids) {
  const [photos, setPhotos] = useState({});
  const key = (ids || []).filter(Boolean).join("|");

  useEffect(() => {
    const wanted = key ? key.split("|") : [];
    if (!wanted.length) return undefined;
    let cancelled = false;
    Promise.all(wanted.map((id) =>
      getArtistHubExtras(id).then((r) => [id, r?.photoURL]).catch(() => [id, null])
    )).then((pairs) => {
      if (cancelled) return;
      setPhotos(Object.fromEntries(pairs.filter(([, url]) => url)));
    });
    return () => { cancelled = true; };
  }, [key]);

  return photos;
}
